import { LanguageCodeEditorEnum } from '@/models/CodeEditorActivity';
import Activity from '../../_deprecated/Activity';
import { ActivityTypeEnum } from '@/models/_deprecated/ActivityElement';
import ActivityElement from '../../_deprecated/ActivityElement';

export enum GenerateDifficultyEnum {
  BEGINNER = 'BEGINNER',
  INTERMEDIATE = 'INTERMEDIATE',
  ADVANCED = 'ADVANCED',
}
export type ActivityInput = {
  lessonId: number;
  activityType: Extract<
    ActivityTypeEnum,
    | ActivityTypeEnum.TRUE_OR_FALSE
    | ActivityTypeEnum.QUIZ
    | ActivityTypeEnum.CODE_EDITOR
  >;
  topic: string;
  difficulty: GenerateDifficultyEnum;
  numQuestions: number;
  additionalInfo: string;
  language?: LanguageCodeEditorEnum;
};

export type QuestionGenerate = Omit<
  ActivityElement,
  'identifier' | 'id' | 'order'
>;

export type ActivityGenerate = Omit<Activity, 'id' | 'questions'> & {
  questions: QuestionGenerate[];
};
